import _ from 'lodash';
import React from 'react';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import Header from '../../../Components/Modules/Includes/Header'
import { Link } from 'react-router-dom'
import * as actions from '../../../Actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Moment from 'react-moment';
import Modal from 'react-modal';
import LinearProgress from 'material-ui/LinearProgress';

Modal.setAppElement('#root')
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		width: '500px',
		transform: 'translate(-50%, -50%)'
	}
};
class Templete extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
			templatetitle: '',
			templateid: '',
			manualid: '',
		}
		this.closeModal = this.closeModal.bind(this);
		this.openModal1 = this.openModal1.bind(this);
		this.registerFileToUpload = this.registerFileToUpload.bind(this);
		this.uploadTemplateFile = this.uploadTemplateFile.bind(this);
		this.stopFormSubmit = this.stopFormSubmit.bind(this);
	}
	componentDidMount() {
		this.props.fetchManuals(0);
	}
	stopFormSubmit(e) {
		e.preventDefault();
	}
	openModal1(e) {
		this.setState({ modalIsOpen: true, templatetitle: e.title, templateid: e._id, manualid: e.manual });
	}
	closeModal() {
		this.setState({ modalIsOpen: false });
	}
	registerFileToUpload(e) {
		const files = [...e.target.files];
		// TODO: Validate this file before adding to the stat
		this.setState({
			uploadFiles: files
		});
	}
	uploadTemplateFile(manual_id, template_id) {
		let companyid = 0;

		if (this.state.uploadFiles) {
			this.props.uploadTemplateFile(manual_id, template_id, companyid, this.state.uploadFiles)
				.then(() => {
					if (this.filesInput) {
						this.filesInput.value = '';
					}
					window.location.reload();
				});

			/*window.setTimeout(() => {
				if(this.filesInput){
				this.filesInput.value = '';
			}
			window.location.reload();	
			}, 2500);*/


		}
	}
	renderGroupedItems() {
		let groupedItems;
		let groups = _.groupBy(this.props.templates.items, 'category');
		groupedItems = _.map(groups, (group, groupName) => {
			let items = group.map((t, i) => {
				var lastupdated;
				if (t.lastUpdated) {
					var now = new Date(t.lastUpdated);
					lastupdated = now;
				}

				return (
					<tr key={`template-${t.title}-${i}`}>
						<td width="30%">{t.title}</td>
						<td width="40%">
							Updated :
	 					{lastupdated ?
								<Moment format=" MMM-DD-YYYY">
									{lastupdated}
								</Moment>
								: ''}
						</td>
						<td width="15%">
							{t.download ?
								<a target="_blank" href={t.download}><i className="zmdi zmdi-download"></i> Download</a>
								:
								'Not found'
							}
						</td>
						<td width="15%">
							<div className="upload-file-sec">
								<label htmlFor="input-file-down" onClick={(e) => { this.openModal1(t, e) }}>
									<i className="zmdi zmdi-upload"></i> Upload
	 						</label>
							</div>
						</td>
					</tr>
				);
			});
			let groupNameText = '';
			let iconClass = '';
			switch (groupName) {
				case 'COVER':
					groupNameText = 'Title Cover Sheet ';
					iconClass = 'zmdi zmdi-file-text';
					break;
				case 'AUDIO_VISUAL':
					groupNameText = 'Audio Visual';
					iconClass = 'zmdi zmdi-volume-up';
					break;
				case 'OTHER_WORKS':
					groupNameText = 'Other Works';
					iconClass = 'zmdi zmdi-case';
					break;
				case 'ELECTRICAL':
					groupNameText = 'Electrical';
					iconClass = 'zmdi zmdi-input-power';
					break;
				case 'FIRE_DETECTION':
					groupNameText = 'Fire Detection';
					iconClass = 'zmdi zmdi-fire';
					break;
				case 'MECHANICAL':
					groupNameText = 'Mechanical';
					iconClass = 'zmdi zmdi-wrench';
					break;
				case 'SECURITY':
					groupNameText = 'Security';
					iconClass = 'zmdi zmdi-shield-security';
					break;
				case 'VOICE_DATA':
					groupNameText = 'Voice Data'
					iconClass = 'zmdi zmdi-phone-in-talk';
					break;
				case 'FLOORING':
					groupNameText = 'Flooring';
					iconClass = 'zmdi zmdi-grid';
					break;
				case 'ROOFING':
					groupNameText = 'Roofing';
					iconClass = 'zmdi zmdi-balance';
					break;
				case 'HVAC':
					groupNameText = 'HVAC'
					iconClass = 'zmdi zmdi-toys';
					break;
				case 'RENEWABLES':
					groupNameText = 'Renewables'
					iconClass = 'zmdi zmdi-refresh';
					break;
				default:
					break;
			}
			return (
				<Panel key={`${groupName}`} eventKey={`template-group-${groupName}`}>
					<Panel.Heading>
						<Panel.Title toggle><i className={iconClass}></i> {groupNameText} </Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible >
						<div className="dashboard-table-data">
							<table width="100%">
								<tbody>
									{items}
								</tbody>
							</table>
						</div>
					</Panel.Body>
				</Panel>
			);
		});
		return groupedItems;
	}
	render() {
		let { templates: { isUploadingFile } } = this.props;
		let groupedItems = null;
		if (this.props.templates && this.props.templates.items && this.props.templates.items.length > 0) {
			groupedItems = this.renderGroupedItems();
		} else {
			groupedItems = 'No tamplates found for that company.'
		}
		let manual_id = this.state.manualid;
		let template_id = this.state.templateid;
		const uploadLabel = isUploadingFile ? 'Uploading...' : 'Upload File';
		return (<div>
			<Header />
			<div className="dashboard-page">
				<div className="right-content-dashboard active-dashboard templete-page">

					<Row>
						<Col md={12}>
							<div className="admin-templete-heading">
								<h3>Master Templates</h3>
							</div>
							<PanelGroup accordion id="accordian-template">
								{groupedItems}
							</PanelGroup>

							<Modal
								isOpen={this.state.modalIsOpen}
								onAfterOpen={this.afterOpenModal}
								onRequestClose={this.closeModal}
								style={customStyles}
								contentLabel="Template Upload Modal"
							>
								<form onSubmit={this.stopFormSubmit} className="upload-file-popup">
									<h2>{this.state.templatetitle}</h2>
									{isUploadingFile && <LinearProgress mode="indeterminate" />} 
									<div className="display-flex">
										<label htmlFor="template-file" id="upload-file-template">
											<input 
												id="template-file" 
												type="file" 
												name="template-file" 
												onChange={this.registerFileToUpload}
												ref={(input) => { this.filesInput = input; }}
												accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
												disabled={isUploadingFile}
												/>
											Choose File
								           	</label>
										<div id="upload-text">
											{this.state.uploadFiles ? this.state.uploadFiles[0].name : 'No file chosen...'}
										</div>
									</div>
									<div>
										<Row>
											<Col md={6}>
												<RaisedButton
													label={uploadLabel}
													type="submit"
													labelColor="#fff"
													fullWidth={true}
													onClick={(e) => { this.uploadTemplateFile(manual_id, template_id) }}
													disabled={isUploadingFile}
												/>
											</Col>
											<Col md={6}>
												<RaisedButton
													label="Cancel"
													type="submit"
													labelColor="#fff"
													fullWidth={true}
													onClick={this.closeModal}
													disabled={isUploadingFile}
												/>
											</Col>
										</Row>
									</div>
								</form>
							</Modal>

						</Col>
					</Row>
				</div>
			</div>
		</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		templates: state.templates,
		manuals: state.manuals,
	};
};

Templete = withRouter(connect(
	mapStateToProps,
	actions
)(Templete));

export default Templete;


// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminTemplate.js